(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var header = document.querySelector('gaia-header');
    var announcement = document.querySelector('.section--announcement-bar');
    if (header && announcement) {
      var announcementHeight = announcement.offsetHeight;
      var headerHeight = header.offsetHeight;
      var totalHeight = headerHeight + announcementHeight;
      document.documentElement.style.setProperty('--header-height', totalHeight + 'px');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
